import { useRecoilValue } from 'recoil';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags';
import { worklistAutoLoadState } from '../state';

export const useWorklistAutoloadState = () => {
  const [isWorklistAutoLoadFeatureEnabled] = useFeatureFlagEnabled(FF.WORKLIST_AUTO_LOAD);
  const worklistAutoLoadRecoilState = useRecoilValue(worklistAutoLoadState);
  const isAutoloadEnabled =
    isWorklistAutoLoadFeatureEnabled && worklistAutoLoadRecoilState?.surface != null;

  return { isAutoloadEnabled, worklistAutoLoadRecoilState };
};
